.attachment {
  display: flex;
  flex-wrap: wrap;
}

.link {
  display: inline-flex;
  align-items: center;
  margin-right: 16px;
  color: var(--color-primary);
  text-decoration: none;
}

.link:hover,
.link:focus {
  text-decoration: underline;
}

.icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}
